import { Navigate, Outlet } from "react-router-dom";
import { observer } from "mobx-react-lite";
import ApiData from "../api/ApiData";

export const CheckRight = observer(() => {

  if (!ApiData.noRight) {
    return <Outlet />;
  } else {
    return <Navigate to="/noright" />;
  }
});
